import { ShareClass } from '@models';

export interface LiteratureDocument {
  docId?: string | null;
  frkOneTISNumber?: string[] | null;
  href?: string | null;
  dctermsTitle?: string | null;
  dctermsDescription?: string | null;
  dctermsAudience?: string[] | null;
  dctermsType?: string | null;
  publicationDate?: string | null;
  frkShareClassCode?: string[] | null;
  literatureHref?: string | null;
  frkReferenceDate?: string | null;
  frkReferenceYear?: string | null;
  shareclass?: ShareClass;
  fileExtension?: string | null;
  frkFundGroupCode?: string | null;
  identifiers?: KeyIdentifiers;
  cmsExternalLink?: string | null;
  nextUpdateDate?: string | null;
  clientUse?: string | null;
  topic?: string[] | null;
  subTopic?: string | null;
  downloadUrl?: string | null;
  fundName?: string | null;
  availableInCart?: boolean;
  reOrderQty?: number | null;
  isSiteIntl?: boolean;
  imageUrl?: string;
  thumbnailPath?: string;
  finraLink?: string;
  pdfDownloadLink?: string;
  assetCategory?: string;
  loginRequired?: boolean;
  orderLimit?: number;
  isOrdItself?: string;
  isInvestor?: boolean;
  exemptCustomers?: string[];
  mandatoryMaterial?: string[];
  quantity?: number;
  literatureCode?: string;
  fileSize?: string;
  description?: string;
  complementaryMaterial?: string[];
  isInv?: string;
  hardCopyNotAvailable?: boolean;
  keywords?: string[];
  litDealerUse?: boolean;
  isMandatoryMaterial?: boolean;
  mandatoryMaterialDependentMsg?: string;
  mandatoryMaterialPrimary?: string;
  blueSkyStates?: string[];
  restrictedDealer?: string[];
  litPathPrevious?: string;
  q1ph?: string;
  q3ph?: string;
  isWidenData?: boolean;
  customFilePath?: string;
  orderDate?: string;
  isSelected?: boolean;
  dctermsLanguage?: string[];
  moreLink?: string;
  isDealerUse?: boolean;
  showShareClass?: boolean;
  languageFilterValues?: string[];
  pdfNumberingAppID?: string | null;
}
export enum Audience {
  Public = 'investor',
  public = 'investor',
  Advisor = 'advisor',
  INSTITUTIONAL = 'institutional',
}
export enum ExemptCustomers {
  B = 'FA',
  E = 'E',
  S = 'SH',
  N = 'Public',
}

export enum FileExtension {
  pdf = 'pdf',
  doc = 'document',
  docx = 'document',
  word = 'document',
  powerpoint = 'ppt',
  pptx = 'ppt',
  oft = 'mail',
  outlook = 'mail',
  xls = 'xls',
  xlsx = 'xls',
  xlsm = 'xls',
}

export enum DocumentMatchCondition {
  FUND_SHARE_CLASS = 'FUND_SHARE_CLASS',
  FUND_ID = 'FUND_ID',
  FUND_UMBRELLA = 'FUND_UMBRELLA',
}

export enum DocumentDctermType {
  ANNUAL_REPORT = 'ANNUAL-REPORT',
  SEMI_ANNUAL_REPORT = 'SEMI-ANNUAL-REPORT',
  SHAREHOLDER_REPORT = 'SHAREHOLDER-REPORT',
  Q3_HOLDING = 'Q3-HOLDING',
  Q1_HOLDING = 'Q1-HOLDING',
}

export interface KeyIdentifiers {
  isin?: string[];
  sedol?: string[];
  bloomberg?: string[];
  taid?: string[];
  cusip?: string[];
  reuterSystem?: string[];
  shareClassFeeStructure?: string[];
  wkn?: string[];
  vln?: string[];
  mexid?: string[];
  rfi?: string[];
  apir?: string[];
  arsn?: string[];
  adm?: string[];
  dsc?: string[];
  ticker?: string[];
  iress?: string[];
  iressinavcode?: string[];
  anbimacode?: string[];
  intradaynav?: string[];
  fundbmticker?: string[];
  shareClassCurrency?: string[];
  distributionIndicator?: string[];
  dividendFrequency?: string[];
}

export interface DocumentList {
  name?: string | null;
  docId?: string | null;
  documentUrl?: string | null;
  downloadUrl?: string | null;
  client?: string;
  itemCardView?: ItemCardView;
  cardView?: ItemCardView[];
  reOrderQty?: number;
  quantity?: number;
  orderLimit?: number;
  isOrdItself?: string;
  isInvestor?: string;
  exemptCustomers?: string;
  mandatoryMaterial?: string[];
  hardCopyNotAvailable?: boolean;
  litDealerUse?: boolean;
  isMandatoryMaterial?: boolean;
  mandatoryMaterialDependentMsg?: string;
  mandatoryMaterialPrimary?: string;
}
export interface StorageItems {
  docId?: string | null;
  quantity?: number;
}

export interface CookieResponse {
  items: string[];
  isError?: boolean;
}
export interface ItemCardView {
  label?: string | null;
  val?: string | null;
  size?: string | null;
}

export interface ItemDetail extends LiteratureDocument {
  loginRequired?: boolean;
  isRestrictedActor?: boolean;
  isRestrictedDealer?: boolean;
}
